import {mapState, mapMutations} from "vuex";
import OauthMixin from "@/common/mixins/oauth-mixins"

export default {
    name: "sign-in",
    mixins: [OauthMixin],
    data() {
        return {
            ready: false,
            admin_login: false,
            background_images: [],
            login: {
                id: '',
                password: ''
            },
            error_message: 'error message',
            show_login_error: false,
            icons: [
                {icon: "feature-1", subject: '稳健', title: "基于流行的视频会议系统，透过API，提供稳健的视频会议建会，查询，报告和录像自动收集等功能"},
                {icon: "feature-2", subject: '高效', title: "合理安排资源，提高视频会议资源的效率，监控资源使用情况，同时管理多个视频会议平台"},
                {icon: "feature-3", subject: '协作', title: "自由灵活分享屏幕，支持聊天、分组讨论，投票，同传，标注、直播、电子白板和影音分享"},
                {icon: "feature-4", subject: '安全', title: "会管平台私有化部署，有SSO对接登录、视频会议有等候室，锁定会议等手段保障会议信息安全"},
            ]
        }
    },
    mounted() {
        if (!this.$organization.sso) {  // 如果设置的是sso 那么就直接跳转连管理员输入都不显示
            let images = ['tsi-ad-banner-0.jpg', 'tsi-ad-banner-1.jpg', 'tsi-ad-banner-2.jpg'];
            if (this.$organization.background_images) {
                images = this.$organization.background_images;
            }
            this.background_images = images.map(item => this.$organization.prefix + '/images/' + item);
        }
    },
    computed: {
        ...mapState(['user', 'process']),
    },
    methods: {
        ...mapMutations('user', ['setUserInfo']),
        resetPassword() {
            const vm = this;
            if (vm.login.id) {
                vm.$affirm('我们将向您的邮箱发送一份包含有密码的邮件, 是否继续?').then(() => {
                    vm.$api('ResetPassword', vm.login, true).then(() => {
                        vm.$messageBox.success('密码已经发出，请检查您的邮箱。');
                    })
                })
            } else {
                vm.$notice.error('请重新输入账号/邮箱');
            }
        },
        submitForm() {
            const vm = this;
            if (!vm.login.id) {
                vm.$notice.error('请重新输入账号/邮箱');
            } else {
                vm.$api('SignIn', vm.login, true).then(response => {
                    vm.setUserInfo(response.data.data);
                    vm.jumpBack();
                });
            }
        },
    },
}
